import React, { useEffect, useRef, useState } from 'react';
import styles from 'styles/admin-detail.module.scss';
import { getImageDownloadUrlForAdmin } from 'api/item_image';
import MaybeLoading from 'utils/MaybeLoading';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalWrapper from "utils/ModalWrapper"
import ReactToPrint from 'react-to-print';
import { Button } from '@material-ui/core';

const VehicleInspectionCertImage = ({ title, s3FileName, isPrintButtonDisabled, customClassName }) => {
  const imageRef = useRef(null);

  const [opensVehicleInspectionCertificateImage, setOpensVehicleInspectionCertificateImage] = useState(false);
  // 画像取得
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    getImageDownloadUrlForAdmin(s3FileName).then(
      setImageUrl,
    );
  }, [s3FileName]);

  const S3Image = React.forwardRef((props, ref) => {
    return <img src={imageUrl} className={styles.vehicleInspectionCertificate} alt="車検証" ref={ref} onClick={props.onClick}/>;
  });

  return (
    <div>
      <p className={styles[customClassName] || styles.label}>
        {title}
        <span>
          <ReactToPrint
            trigger={() => (
              <Button
                type="button"
                variant="outlined"
                color="primary"
                disabled={imageUrl === '' || isPrintButtonDisabled}
                className={styles.printButton}
              >
                印刷
              </Button>
            )}
            content={() => imageRef.current}
          />
        </span>
      </p>
      <div>
        <MaybeLoading
          progressComponent={
            <div className={styles.downloadLoading}>
              <CircularProgress />
            </div>
          }
          loading={imageUrl === ""}
        >
          <S3Image
            ref={imageRef}
            onClick={() =>
              setOpensVehicleInspectionCertificateImage(true)
            }
          />
        </MaybeLoading>
      </div>
      <ModalWrapper
        open={opensVehicleInspectionCertificateImage}
        scroll={false}
        handleClose={() => setOpensVehicleInspectionCertificateImage(false)}
        content={
          <img src={imageUrl} alt="車検証" className={styles.modalImage} />
        }
        showCloseButton
      />
    </div>
  )
}

export default VehicleInspectionCertImage